// @flow

import React, { Component } from 'react';
import * as d3 from 'd3';

import Tooltip from '../Tooltip/Tooltip';

import './LocatedCircles.css';

const defaultCalculateFill = d => '#D3D3D3';
const defaultcalculateStroke = d => 'none';
const defaultcalculateStrokeWidth = d => 0;

class LocatedCircles extends Component {
  clearTooltip: Function;
  init: Function;
  locations: Object;
  node: Object;
  selectLocation: Function;
  update: Function;
  updateTooltip: Function;

  constructor(props: Object) {
    super(props);
    this.update = this.update.bind(this);
    this.updateTooltip = this.updateTooltip.bind(this);
    this.clearTooltip = this.clearTooltip.bind(this);
    this.selectLocation = this.selectLocation.bind(this);
  }

  componentDidMount() {
    this.update();
  }
  componentDidUpdate() {
    this.update();
  }

  shouldComponentUpdate(nextProps: Object) {
    if (!this.readyCheck()) {
      return true;
    }

    return (
      this.props.scale !== nextProps.scale ||
      this.props.lastUpdate !== nextProps.lastUpdate ||
      this.props.locations !== nextProps.locations ||
      this.props.calculateLocation !== nextProps.calculateLocation
    );
  }

  init() {
    const node = d3.select(this.node);
    node.append('g').attr('class', 'bubbles');
  }

  readyCheck() {
    return this.props.locations && Array.isArray(this.props.locations);
  }

  updateTooltip(d: Object) {
    Tooltip.update(this.props.buildTooltip(d));
  }

  clearTooltip() {
    Tooltip.update();
  }

  selectLocation(d: Object) {
    if (this.props.onSelection) {
      this.props.onSelection(d);
    }
  }

  update() {
    if (!this.readyCheck()) {
      return;
    }

    const allLocations = [...this.props.locations];

    allLocations.forEach(d => {
      d.svgLocation = this.props.calculateLocation(d);
    });

    this.locations = allLocations.filter(d => {
      return d.svgLocation && Array.isArray(d.svgLocation);
    });

    this.locations.sort((a, b) => {
      return this.props.calculateArea(b) - this.props.calculateArea(a);
    });

    const calculateArea = this.props.calculateArea;
    const calculateFill = this.props.calculateFill || defaultCalculateFill;
    const calculateStroke = this.props.calculateStroke || defaultcalculateStroke;
    const calculateStrokeWidth = this.props.calculateStrokeWidth || defaultcalculateStrokeWidth;

    const node = d3.select(this.node);
    if (node.select('g.bubbles').empty()) {
      this.init();
    }

    const bubblesG = node.select('g.bubbles');

    const circles = bubblesG
      .selectAll('circle.bubble')
      .data(this.locations, this.props.keyFunction);

    circles.exit().remove();

    circles
      .enter()
      .append('circle')
      .attr('class', 'bubble')
      .attr('cx', d => {
        if (!d.svgLocation) {
          return 0;
        }
        return d.svgLocation[0];
      })
      .attr('cy', d => {
        if (!d.svgLocation) {
          return 0;
        }
        return d.svgLocation[1];
      })
      .attr('r', d => {
        return Math.sqrt(calculateArea(d) / Math.PI) / this.props.scale;
      })
      .attr('fill', calculateFill)
      .attr('stroke', calculateStroke)
      .attr('stroke-width', d => {
        return calculateStrokeWidth(d) / this.props.scale;
      })
      .style('cursor', this.props.onSelection ? 'pointer' : 'default')
      .on('mouseover', this.updateTooltip)
      .on('mousemove', this.updateTooltip)
      .on('mouseleave', this.clearTooltip)
      .on('click', this.selectLocation);

    circles
      .attr('r', d => {
        return Math.sqrt(calculateArea(d) / Math.PI) / this.props.scale;
      })
      .attr('cx', d => {
        if (!d.svgLocation) {
          return 0;
        }
        return d.svgLocation[0];
      })
      .attr('cy', d => {
        if (!d.svgLocation) {
          return 0;
        }
        return d.svgLocation[1];
      })
      .attr('fill', calculateFill)
      .attr('stroke', calculateStroke)
      .attr('stroke-width', d => {
        return calculateStrokeWidth(d) / this.props.scale;
      });
  }

  render() {
    return <g className="LocatedCircles" ref={node => (this.node = node)} />;
  }
}

export default LocatedCircles;



// WEBPACK FOOTER //
// ./src/components/LocatedCircles/LocatedCircles.js